import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { UploadTransactionFile } from "../../../services/transactionService";
import * as SnackbarActions from "../../../store/SnackbarStore";

const styles = {
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400
  },
  input: {
    marginLeft: 8,
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  },
  fileInput: {
    display: "none"
  }
};

class CustomizedInputBase extends Component {
  state = {
    file: undefined
  };
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  openFileDialog = () => {
    this.fileInputRef.current.click();
  };

  onFilesAdded = event => {
    if (this.props.disabled) return;
    const files = event.target.files;
    if (files) {
      this.setState({ file: files[0] });
    }
  };

  onFileUpload = async event => {
    const { file } = this.state;
    if (this.state.file) {
      await this.sendRequest(file);
      this.fileInputRef.current.value = "";
      this.setState({ file: undefined });
    }
  };

  sendRequest = async file => {
    const { sendError, sendMessage } = this.props;
    try {
      const result = await UploadTransactionFile(file);
      debugger;
      sendMessage({ message: `${result.fileName} uploaded!` });
    } catch (error) {
      sendError(error);
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.root} elevation={1}>
        <InputBase
          className={classes.input}
          placeholder="Select File"
          value={this.state.file ? this.state.file.name : ""}
          disabled
        />
        <input
          ref={this.fileInputRef}
          className={classes.fileInput}
          type="file"
          onChange={this.onFilesAdded}
        />
        <IconButton
          className={classes.iconButton}
          aria-label="Select File"
          onClick={() => {
            this.openFileDialog();
          }}
        >
          <FolderOpenIcon />
        </IconButton>
        <Divider className={classes.divider} />
        <IconButton
          color="primary"
          className={classes.iconButton}
          aria-label="Upload"
          onClick={this.onFileUpload}
        >
          <CloudUploadIcon />
        </IconButton>
      </Paper>
    );
  }
}

CustomizedInputBase.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  state => state,
  dispatch =>
    bindActionCreators(
      Object.assign({}, SnackbarActions.actionCreators),
      dispatch
    )
)(withStyles(styles)(CustomizedInputBase));
